"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const Search_1 = __importDefault(require("@kyruus/react-ikons/Search"));
const Cancel_1 = __importDefault(require("@kyruus/react-ikons/Cancel"));
const input_1 = __importDefault(require("@kyruus/input"));
const messages_1 = require("../../lib/messages");
const styles_1 = require("./styles");
const SearchInput = ({ id, itemType, value, enableClearInput, isV9Profile, onChange, onCancel, intl }) => {
    const searchIcon = (() => {
        if (enableClearInput && value) {
            return null;
        }
        return (react_1.default.createElement(styles_1.SearchIconWrapper, { "aria-hidden": "true" },
            react_1.default.createElement(Search_1.default, null)));
    })();
    const clearSearchIcon = enableClearInput && value && onCancel ? (react_1.default.createElement(styles_1.CancelButton, { onClick: onCancel, "data-testid": "InfoListBoxSearchCancel", "aria-label": intl.formatMessage(messages_1.messages.infoListBoxClearSearch) },
        react_1.default.createElement(Cancel_1.default, null))) : null;
    const inputLabel = intl.formatMessage(messages_1.messages.infoListBoxSearchAriaLabel, {
        item: typeof itemType === 'string' ? itemType.toLowerCase() : itemType
    });
    return (react_1.default.createElement(styles_1.SearchInputWrapper, { "data-testid": `${id}-Search`, isV9Profile: isV9Profile },
        react_1.default.createElement(input_1.default, { id: id, name: id, value: value, label: inputLabel, "aria-label": inputLabel, hideLabel: true, onChange: onChange, "data-testid": `${id}-SearchInput` }),
        searchIcon,
        clearSearchIcon));
};
exports.default = (0, intl_1.injectIntl)(SearchInput);
//# sourceMappingURL=SearchInput.js.map